<template>
 <div id="modifyPassword">
    <mt-header title="修改密码"  fixed>
		  <a href="javascript:void(0)" slot="left" @click="returnBack">
			    <mt-button icon="back" class="font-Yahei"></mt-button>
		  </a>
	</mt-header>
	<section class="loginContent mt40">		
			<div class="login_linem">
				<!--<i class="logIco"><img src="../../../static/images/password_login.png"/></i>-->
				<input  :type="typepasswardo" placeholder="原密码" maxlength="20" v-model="oldpassword"/>				
				<i @click="changetypeo" class="logIco2"><img :src="srcopeno"/></i>
				
			</div>
			<div class="login_linem">
				<!--<i class="logIco"><img src="../../../static/images/change_keyg.png"/></i>-->
				<input  :type="typepasswardn" placeholder="新密码" maxlength="20" v-model="newpassword"/>
				<i @click="changetypen" class="logIco2"><img :src="srcopenn"/></i>
			</div>
			
			<p><input type="button" value="确认修改" class="btnLogin" @click="userconfire"/></p>
	</section>
 </div>
</template>

<script>
    import { Toast } from 'mint-ui'
	import { Indicator } from 'mint-ui'
	export default{
		data(){
			return{
			   username:localStorage.getItem("username"),   //用户名
               oldpassword:"",
               newpassword:"",
               typepasswardo:'password',
               srcopeno:'../../../static/images/closeeye.png',
               typepasswardn:'password',
               srcopenn:'../../../static/images/closeeye.png',
			}
		},
	    methods: {
	    	returnBack(){
	       	 this.$router.go(-1);
	        },
	        changetypeo(){
	           if(this.typepasswardo=='password'){
	           	 this.typepasswardo='text';
	           	 this.srcopeno='../../../static/images/openeye.png';
	           }else{
	           	 this.typepasswardo='password';
	           	 this.srcopeno='../../../static/images/closeeye.png';
	           }
	        },
	        changetypen(){
	        	if(this.typepasswardn=='password'){
	           	 this.typepasswardn='text';
	           	 this.srcopenn='../../../static/images/openeye.png';
	           }else{
	           	 this.typepasswardn='password';
	           	 this.srcopenn='../../../static/images/closeeye.png';
	           }
	        },
	     	userconfire(){
	     		if(this.validatepassword()){
	     			if(this.validatepassword2()){
		     		  Indicator.open();
		     		  this.$http.post(this.URL_PREFIX+"/user/updateUserPwdByName.net",{uName:this.username,pwd:this.oldpassword,newPwd:this.newpassword})
					  .then((res) =>{
				  		Indicator.close();
				  		if(res.data.code!=200){
				  			Toast(res.data.msg);
				  		}else{
				  			Toast(res.data.msg);
				  			this.$router.push({path: "/UserCenter"});
						}
				  	});
			  	}
		      }
	       },
	        //原密码验证
	     	validatepassword(){
//	     		var reg=/^[A-Za-z0-9_~!@#$%^&*￥—+？|/<>=;:`,.\\(){}]{6,20}$/;
	     		var reg= /^[a-zA-Z0-9\W_!@#$%^&*`~()-+=?]{6,20}$/
	     		var reg2 = /\s+/g;
	     		var reg3 = /[\u4E00-\u9FFF]/g;
	     		var reg4 = /[\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5]/;
	     		if(this.oldpassword==''){
                    Toast("请输入原密码");
                   return false;
                }else if(reg2.test(this.oldpassword)){
                   Toast("原密码不能包含空格");
                   return false;
                }else if(!reg.test(this.oldpassword)){
                    Toast("原密码必须为6-20位字母、数字或符号");
                    return false;
                }else if(reg3.test(this.oldpassword)){
                    Toast("原密码不能包含中文");
                    return false;
                }else if(reg4.test(this.oldpassword)){
                    Toast("原密码不能包含中文符号");
                    return false;
                }else{
                	return true;
                }
	     	},
	     	//新密码验证
	     	validatepassword2(){
//	     		var reg=/^[A-Za-z0-9_~!@#$%^&*￥—+？|/<>=;:`,.\\(){}]{6,20}$/;
	     		var reg= /^[a-zA-Z0-9\W_!@#$%^&*`~()-+=?]{6,20}$/
	     		var reg2 = /\s+/g;
	     		var reg3 = /[\u4E00-\u9FFF]/g;
	     		var reg4 = /[\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5]/;
	     		if(this.newpassword==''){
                    Toast("请输入新密码");
                   return false;
                }else if(reg2.test(this.newpassword)){
                   Toast("新密码不能包含空格");
                   return false;
                }else if(!reg.test(this.newpassword)){
                    Toast("新密码必须为6-20位字母、数字或符号");
                    return false;
                }else if(reg3.test(this.newpassword)){
                    Toast("新密码不能包含中文");
                    return false;
                }else if(reg4.test(this.newpassword)){
                    Toast("新密码不能包含中文符号");
                    return false;
                }else{
                	return true;
                }
	     	}
	    }
	}
</script>

<style scoped="scoped">
.loginContent{width: 85%;margin: 150px auto 45px;}
.login_linem{border-bottom: 1px solid #e0e0e0 ;padding: 10px;margin-bottom: 10px;overflow: hidden;}
.login_linem input{float:left;width: 74%;color: #333;font-size: 1.0rem;border: none;background: transparent;line-height: 30px;margin-left: 20px;}
.logIco2{width: 20px;height: 20px;margin-top: 3px;float:right;}
.logIco2 img{width: 100%;}
/*.logIco{width: 20px;height: 20px;margin-top: 3px;float:left;}
.logIco img{width: 100%;}*/
.btnLogin{width: 100%;height: 40px;background: #ff8920;color: #fff;font-size: 1.0rem;border-radius: 5px;-webkit-border-radius: 5px;margin-top:15px;border: none;line-height: 40px;}
.btnSend1{border: none;background: transparent;width: 25px;}
</style>     


// WEBPACK FOOTER //
// src/views/UserCenter/modifyPassword.vue